window.$ = window.jQuery = require('jquery');
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export default function() {
    let photoswipeElement = document.querySelector('.pswp');
    if (!photoswipeElement) {
        console.error('Photoswipe element was not found');
        return;
    }

    function create_gallery(element) {
        let jqueryElement = $(element);
        if (jqueryElement.length == 0) {
            return false;
        }
        let items = [];
        jqueryElement.find('a').each( function() {
            let jqueryThis = $(this);
            if (jqueryThis.parent().hasClass('slick-cloned')) {
                return;
            }
            let $size = jqueryThis.data('size').split('x');

            this.dataset.index = items.length;

            items.push({
                src : this.getAttribute('href'),
                w   : parseInt($size[0]),
                h   : parseInt($size[1])
            });
        });
        jqueryElement.on('click', 'figure', function(event) {
            event.preventDefault();

            let imageIndex = this.querySelector('a').dataset.index || false;
            let options = {
                index: parseInt(imageIndex),
                bgOpacity: 0.7,
                showHideOpacity: true
            }

            window.location.hash = '';

            let lightBox = new PhotoSwipe(photoswipeElement, PhotoSwipeUI_Default, items, options);
            lightBox.init();
        });
    }

    function openPhotoSwipe(element) {
        let items = [];
        element.find('a').each( function() {
            let jqueryThis = $(this);
            if (jqueryThis.parent().hasClass('slick-cloned')) {
                return;
            }
            let $size = jqueryThis.data('size').split('x');

            items.push({
                src : this.getAttribute('href'),
                w   : $size[0],
                h   : $size[1]
            });
        });

        let index = element.slick('slickCurrentSlide') || 0;
        let options = {
            bgOpacity: 0.7,
            showHideOpacity: true,
            index: index,
        }

        window.location.hash = '';

        let lightBox = new PhotoSwipe(photoswipeElement, PhotoSwipeUI_Default, items, options);
        lightBox.init();
    }

    create_gallery('.slick-gallery');

    let slickGallery = $('.slick-gallery');
    slickGallery.slick({
        slidesToShow: 1,
        rows: 0
    });

    try {
        slickGallery.slick('slickUnfilter').slick('slickFilter', '.default');
    } catch (error) {
        console.error(error);
    }

    // $('.slick-gallery').slickCurrentSlide()
    create_gallery('.lightbox-gallery');
    create_gallery('.thumbnails-to-zoom');

    $('.gallery-actions__angle-btn--full').click(function() {
        openPhotoSwipe(slickGallery);
    });

    $('.gallery-actions__angle-btn--interior').click(function() {
        // $('#videoGallery').hide();
        $('#galleryCarousel').show();
        slickGallery.slick('slickUnfilter').slick('slickFilter', '.interior-image');
    });

    $('.gallery-actions__angle-btn--exterior').click(function() {
        // $('#videoGallery').hide();
        $('#galleryCarousel').show();
        slickGallery.slick('slickUnfilter').slick('slickFilter', '.exterior-image');
    });

    $('.gallery-actions__swatch').on('click', function() {
        $('.gallery-actions__swatch').removeClass('gallery-actions__swatch--active');
        $('#galleryCarousel').show();
        $('.gallery-actions__paint-name').text($(this).data('paint-name'));

        $(this).addClass('gallery-actions__swatch--active');

        slickGallery.slick('slickUnfilter').slick('slickFilter', `.exterior-${$(this).data('paint')}`);
    });

    $(document).on('beforeChange', slickGallery, function (event, slick, currentSlide, nextSlide){
        nextSlide = slick.$slides.get(nextSlide);
        let $slideSourceSet = $(nextSlide).find('source');
        $($slideSourceSet).each(function() {
            $(this).attr('srcset', $(this).data('lazy-srcset'));
        });
        let $slideImgSet = $(nextSlide).find('img');
        $($slideImgSet).each(function() {
            $(this).attr('srcset', $(this).data('lazy-srcset'));
        });
    });

    slickGallery.on('reInit', function(event, slick){
        let nextSlide = slickGallery.slick('slickCurrentSlide');
        nextSlide = slick.$slides.get(nextSlide);
        let $slideSourceSet = $(nextSlide).find('source');
        $($slideSourceSet).each(function() {
            $(this).attr('srcset', $(this).data('lazy-srcset'));
        });
        let $slideImgSet = $(nextSlide).find('img');
        $($slideImgSet).each(function() {
            $(this).attr('srcset', $(this).data('lazy-srcset'));
        });
    });

    // $('.showVideo').click(function() {
    //     $('#galleryCarousel').hide();
    //     $('#videoGallery').show();
    // });
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/setup-photoswipe.js